import { PointerShape } from "./pointer-shape";

export interface IBrushSettings {
  size: number;
  shape: PointerShape;
}